export default __webpack_public_path__ + "static/media/bg-gradient-chiriasi-new.7f072260.png";